var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,2.3C12.1,0.8,10.1,0,8,0S3.9,0.8,2.3,2.3c-3.1,3.1-3.1,8.2,0,11.3C3.9,15.2,5.9,16,8,16s4.1-0.8,5.7-2.3 C15.2,12.1,16,10.1,16,8S15.2,3.9,13.7,2.3z M13,13C11.6,14.3,9.9,15,8,15S4.4,14.3,3,13C0.3,10.2,0.3,5.8,3,3C4.4,1.7,6.1,1,8,1 s3.6,0.7,5,2.1C14.3,4.4,15,6.1,15,8S14.3,11.6,13,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,11.7H8.5V7c0-0.3-0.2-0.5-0.5-0.5H7C6.7,6.5,6.5,6.7,6.5,7c0,0.3,0.2,0.5,0.5,0.5h0.6v4.2H7 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5H9c0.3,0,0.5-0.2,0.5-0.5C9.5,11.9,9.3,11.7,9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,5.7c0.7,0,1.3-0.6,1.3-1.3S8.7,3.1,8,3.1S6.7,3.6,6.7,4.4S7.3,5.7,8,5.7z M8,3.9c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C7.6,4.1,7.8,3.9,8,3.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDetails);
export default __webpack_public_path__ + "static/media/task-details.0ce8fc0b6c97f78756393cd372c08003.svg";
export { ForwardRef as ReactComponent };